import {OwnerPayload, ResolveOwner, TeamId, UserId, UserMin} from "../Types.ts";
import {unreachableCase} from "./typescript.ts";
import api from "../api";

export function getContentId(owner: OwnerPayload): UserId | TeamId {
  switch (owner.type) {
    case "User":
      return owner.content.user_id;
    case "Team":
      return owner.content.team_id;
    default:
      unreachableCase(owner);
  }
}

export function getOwnerNames(owner: OwnerPayload): string[] {
  switch (owner.type) {
    case "User":
      return [owner.content.name, owner.content.primary_email].flatMap(n => (n ? [n] : []));
    case "Team":
      return [owner.content.name];
    default:
      unreachableCase(owner);
  }
}

function toResolveRequest(owner: OwnerPayload): ResolveOwner {
  switch (owner.type) {
    case "User":
      return {type: "User", content: owner.content.user_id};
    case "Team":
      return {type: "Team", content: owner.content.team_id};
    default:
      unreachableCase(owner);
  }
}

export async function resolveToOwners(owners: OwnerPayload[]) {
  if (owners.length > 0) {
    const ids: ResolveOwner[] = owners.map(toResolveRequest);
    return await api.owners.resolve(ids);
  } else {
    return [];
  }
}

export function isPlatformedUser(user: UserMin) {
  return (user.primary_email ?? "").endsWith("@platformed.com");
}
